import React from 'react';
import styled from 'styled-components';

const CertificationsContainer = styled.div`
  h4 {
    color: var(--white);
    margin-bottom: 1rem;
    text-align: center;
    font-size: 1rem;
    font-weight: 600;
  }
`;

const CertificationsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
    gap: 1.5rem;
  }
`;

const CertificationItem = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: var(--white);
  opacity: 0.9;
  transition: all 0.3s ease;
  padding: 0.75rem;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  min-width: 120px;

  &:hover {
    opacity: 1;
    transform: translateY(-2px);
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }
`;

const CertificationImage = styled.img`
  height: 40px;
  width: auto;
  margin-bottom: 0.5rem;
  transition: all 0.3s ease;
  opacity: 0.9;
  border-radius: 4px;

  ${CertificationItem}:hover & {
    opacity: 1;
    transform: scale(1.05);
  }
`;

const CertificationText = styled.span`
  font-size: 0.75rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const Certifications: React.FC = () => {
  return (
    <CertificationsContainer>
      <h4>Certificações</h4>
      <CertificationsGrid>
        <CertificationItem
          href="https://idadedeouro.pt/covid-19/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Clean & Safe - Turismo de Portugal"
        >
          <CertificationImage
            src="/images/certifications/selo-final-logo-Cópia.webp"
            alt="Clean & Safe - Turismo de Portugal"
            loading="lazy"
          />
          <CertificationText>Clean & Safe</CertificationText>
        </CertificationItem>

        <CertificationItem
          href="https://idadedeouro.pt/covid-19/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Selo de Excelência"
        >
          <CertificationImage
            src="/images/certifications/logo-excelencia-1.webp"
            alt="Selo de Excelência"
            loading="lazy"
          />
          <CertificationText>Selo de Excelência</CertificationText>
        </CertificationItem>
      </CertificationsGrid>
    </CertificationsContainer>
  );
};

export default Certifications;
